export enum TRACK_TYPE {
  LOOP = 'loop',
  SFX_LOOP = 'sfx_loop',
  SHORT = 'short',
  STEM = 'stem',
  MAIN_SD = 'main_sd',
  MAIN_HD = 'main_hd',
  SFX = 'sfx'
}
